import React from 'react';
import './App.scss';
import { Header } from './components/Header';
//import Footer from './components/Footer';
import { BrowserRouter as Router,Redirect, Route } from "react-router-dom";


//Declare New Components Here
import Home from './components/Home';
import PersonalDetails from "./components/PersonalDetails.jsx";
import LoanCalculator from "./components/LoanCalculator";
import ReviewDetails from "./components/ReviewDetails";
import errorscreen from "./components/error";

function App() {
  return (
    <Router>
        <div className="content">
          <Header projectName={'mbank_termloan'} />
          <Route exact path="/" ><Redirect to="/termloan" /></Route>
          <Route exact path="/termloan" component={PersonalDetails} /> 
          <Route path = "/termloan/home" component={Home} /> 
          <Route path = "/termloan/loancalc" component={LoanCalculator} />
          <Route path = "/termloan/ReviewDetails" component={ReviewDetails} />
          <Route path = "/termloan/error" component={errorscreen} />
          
        </div>
        <br></br><br></br>
        {/* <div className="footer">
          <Footer />
        </div> */}
    </Router>
  );
}


export default App;
